import { useNavigate } from 'react-router'
import { useRunQuery } from '@hooks/useQuery'
import { FormattedMessage } from 'react-intl'
import { useAppSelector } from 'universal-scripts'
import { useTrialGuard } from '@hooks/useTrialGuard'

import './RunButton.css'

interface RunButtonProps {
  id: string
  mini?: boolean
  onSuccess?: (id: string) => void | Promise<unknown>
}

export default function RunButton({ id, mini, onSuccess }: RunButtonProps) {
  const navigate = useNavigate()
  const { runQuery, refreshQueryInfo } = useRunQuery()
  const isLoggedIn = useAppSelector((state) => !!state.user)
  const { guard } = useTrialGuard()

  if (!isLoggedIn) return

  const handleRun = async () => {
    try {
      await runQuery(id)

      if (onSuccess) {
        await onSuccess(id)
      } else {
        await refreshQueryInfo(id)
        navigate(`/queries/${id}`)
      }
    } catch (error) {
      alert('Error running query: ' + error)
    }
  }

  const className = ['run-button', mini && 'run-button-mini']
    .filter(Boolean)
    .join(' ')

  return (
    <button className={className} onClick={guard(handleRun)}>
      <span className="icon icon-play-filled" />
      {!mini && (
        <span className="text only-desktop">
          <FormattedMessage id="run" />
        </span>
      )}
    </button>
  )
}
